import { ObjectBuilder, Rectangle3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
export class MenuPopupContainer extends Rectangle3D {
    constructor(name, mesh2D, layout) {
        super(name);
        this.hide = () => {
            this.isVisible = false;
            this._resetTimer();
        };
        this.show = (text) => {
            this._message.text = text;
            this.isVisible = true;
            this._resetTimer();
            this._timeout = setTimeout(this.hide, Env.broadcast.menu.chat.popUp.timeoutMs);
        };
        this.widthInPixels = mesh2D.m2px(layout.width);
        this.heightInPixels = mesh2D.m2px(layout.height);
        this.cornerRadius = mesh2D.m2px(layout.cornerRadius);
        this.background = layout.backgroundColor;
        this.thickness = 0;
        this._message = ObjectBuilder.createTextBlock3D(mesh2D, "message", "", {
            color: layout.fontColor,
            fontSize: layout.fontSize,
            height: layout.height,
            width: layout.width
        });
        this._message.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        this._message.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        this._message.textWrapping = TextWrapping.WordWrap;
        this.addControl(this._message);
    }
    _resetTimer() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = undefined;
        }
    }
}
